import { Routes, withInMemoryScrolling } from '@angular/router';
import { RouteGuard } from './core/guards/route.guard';

// emits the Scroll event on which ErrorService shows the errors handed over in the navigation state
export const APP_ROUTER_FEATURES = [withInMemoryScrolling()];

export const APP_ROUTES: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'public',
    loadComponent: () => import('./layouts/public-layout/public-layout.component').then((m) => m.PublicLayoutComponent),
    loadChildren: () => import('./modules/public/public.routes').then((m) => m.publicRoutes)
  },
  {
    path: 'new-user',
    loadComponent: () => import('./layouts/content-layout/content-layout.component').then((m) => m.ContentLayoutComponent),
    loadChildren: () => import('./modules/new-user/new-user.routes').then((m) => m.newUserRoutes)
  },
  {
    path: '',
    loadComponent: () => import('./layouts/content-layout/content-layout.component').then((m) => m.ContentLayoutComponent),
    canActivate: [RouteGuard],
    children: [
      {
        path: 'home',
        loadChildren: () => import('./modules/home/home.routes').then((m) => m.homeRoutes)
      },
      {
        path: 'order',
        loadChildren: () => import('./modules/order/order.routes').then((m) => m.orderRoutes)
      },
      {
        path: 'epd',
        loadChildren: () => import('./modules/epd/epd.routes').then((m) => m.epdRoutes)
      },
      {
        path: 'company',
        loadChildren: () => import('./modules/company/company.routes').then((m) => m.companyRoutes)
      },
      {
        path: 't',
        loadChildren: () => import('./modules/t/t.routes').then((m) => m.tRoutes)
      }
    ]
  },
  {
    path: '**',
    loadComponent: () => import('./layouts/public-layout/public-layout.component').then((m) => m.PublicLayoutComponent)
  }
];
